import { CLAUSE_SPINE } from "@/lib/data";

/** Left-margin clause-spine — signature ornament. */
export default function Spine() {
  return (
    <div className="spine" aria-hidden="true">
      {CLAUSE_SPINE.map((c, i) => (
        <div key={c + i} style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}>{c}</div>
      ))}
    </div>
  );
}
